<template>
  <div class="col-xs-12 col-md-3">
    <form-group-search-select
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="options"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>

import CampoEnum from "../../../../domain/protocolo/CampoEnum";

export default {
  name: "c-protocolo-modalidade-ensino",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    options() {
      return [
        {
          value: "ead",
          text: "EAD"
        },
        {
          value: "presencial",
          text: "Presencial"
        }
      ];
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/modalidadeEnsino.vue